export default __webpack_public_path__ + "static/shield-uchicago-aeff8420381366daab45aa18926d1e22.svg";